export default "__VITE_ASSET__DwvaG_i0__"